import CodiceFiscale from 'codice-fiscale-js'
import map from 'lodash/map'
import numeral from 'numeral'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  customerUpdate,
  phaseChange,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import { putClienti, putClientiCallback } from '../../../actions/buy/Clienti'
import {
  searchComuniV2Cittadinanza,
  searchComuniV2LuogoNascita,
  searchComuniV2Residenza,
} from '../../../actions/noleggia/Comuni'
import verify from '../../../modules/verify'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import {
  getCodiceCastale,
  transformCittadinanzaDefaultValue,
  transformComuniCittadinanzaV2Result,
  transformComuniNazioniDefaultValue,
  transformComuniResidenzaV2Result,
  transformComuniV2Result,
} from '../../../utils/searchComuniUtils'
import PhoneInput from '../../Input/Phone'
import DocumentiHelperModal from '../../noleggia/dumb/DocumentiHelperModal'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyDataForm from '../dumb/BuyDataForm'
import BuyDateInput from '../dumb/BuyDateInput'
import BuyRadioInput from '../dumb/BuyRadioInput'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import BuyTerminiDiUtilizzo from '../dumb/BuyTerminiDiUtilizzo'
import BuyTextInput from '../dumb/BuyTextInput'
import BuyTextInput2 from '../dumb/BuyTextInput2'
import {
  haGaranzia3Anni,
  mapfreAssistenzaStradale,
  mapfreCondizioniGeneraliContratto,
  mapfreInformativaDatiPersonali,
  mapfreProgrammaGaranzia,
} from '../utils'

class BuyDataFormBank extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.section = 1
    this.state.toTop = false
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRadio = this.handleRadio.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.against_map = this.against_map.bind(this)
    this.validate = this.validate.bind(this)
    this.state.flagDomicilio = false
    this.state.flagResidenza = false

    this.refCivicoConsegna = React.createRef()
    this.refIndirizzoConsegna = React.createRef()

    this.state.show_condizioni_generali_di_contratto_modal = false
    this.state.show_termini_di_utilizzo_modal = false
    this.state.cap_residenza = this.props.customer.cap_residenza || ''
    this.state.caps_residenza = this.props.customer.caps_residenza || []
    this.state.select_cap_residenza =
      this.props.customer.select_cap_residenza || false
    this.state.cap_domicilio = this.props.customer.cap_domicilio || ''
    this.state.cap_fatturazione = this.props.customer.cap_fatturazione || ''
    this.state.caps_domicilio = this.props.customer.caps_domicilio || []
    this.state.caps_fatturazione = this.props.customer.caps_fatturazione || []
    this.state.select_cap_domicilio =
      this.props.customer.select_cap_domicilio || false
    this.state.select_cap_fatturazione =
      this.props.customer.select_cap_fatturazione || false

    this.state.cap_consegna = this.props.customer.cap_consegna || ''
    this.state.caps_consegna = this.props.customer.caps_consegna || []
    this.state.select_cap_consegna =
      this.props.customer.select_cap_consegna || false

    this.state.dati_cliente_nome_error = ''
    this.state.dati_cliente_cognome_error = ''
    this.state.dati_cliente_phone_error = ''
    this.state.dati_cliente_email_error = ''
    this.state.dati_cliente_sesso_error = ''
    this.state.dati_cliente_data_di_nascita_error = ''
    this.state.dati_cliente_comune_nascita_error = ''
    this.state.dati_cliente_codice_fiscale_error = ''
    this.state.dati_cliente_partita_iva_error = ''
    this.state.dati_cliente_cittadinanza_error = ''
    this.state.dati_cliente_citta_residenza_error = ''
    this.state.dati_cliente_cap_residenza_error = ''
    this.state.dati_cliente_indirizzo_residenza_error = ''
    this.state.dati_cliente_numero_civico_residenza_error = ''

    this.state.dati_cliente_citta_consegna_error = ''
    this.state.dati_cliente_cap_consegna_error = ''
    this.state.dati_cliente_indirizzo_consegna_error = ''
    this.state.dati_cliente_numero_civico_consegna_error = ''

    this.state.dati_cliente_domicilio_diverso_error = ''
    this.state.dati_cliente_condizioni_brumbrum_obbligatorie_error = ''
    this.state.dati_cliente_citta_domicilio_error = ''
    this.state.dati_cliente_cap_domicilio_error = ''
    this.state.dati_cliente_indirizzo_domicilio_error = ''
    this.state.dati_cliente_civico_domicilio_error = ''
    this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error =
      ''
    this.state.dati_cliente_fatturazione_uguale_error = ''
    this.state.dati_cliente_cap_fatturazione_error = ''
    this.state.dati_cliente_citta_fatturazione_error = ''
    this.state.dati_cliente_indirizzo_fatturazione_error = ''
    this.state.dati_cliente_numero_civico_fatturazione_error = ''
    this.state.dati_cliente_ragione_sociale_error = ''
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
    this.handleSelect('cittadinanza')(
      this.props.customer.cittadinanza || {
        label: 'italiana',
        value: 'ITA|italiana',
      }
    )
    if (this.props.customer) {
      map(this.props.customer, (value, key) => {
        if (typeof value === 'string') {
          this.validate(`dati_cliente_${key}`, value)
        }
      })
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 30 })

    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }

    this.props.storeDumpItForce()
    triggerClickStreamEvent(
      CRITEO_EVENTS.BASKET_FUNNEL_PERSONAL_DATA,
      EVENT_TYPES.CRITEO,
      {
        email: this.props.customer.email,
        idAuto: this.props.product.id_auto,
        price: numeral(
          this.props.ordine.totale - this.props.ordine.acconti
        ).format('$ 0,0[.]00'),
      }
    )
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.error.display === true &&
      this.props.error.display === false
    ) {
      // l'utente ha chiuso il popup di errore
      this.handlePrev()
    }
  }

  cleanUpField(ref) {
    if (!ref || !ref.current) {
      return
    }

    ref.current.querySelector('input').value = ''
  }

  validate(label, value, requireAttention = false, showError = true) {
    const v = verify(label, value, this.against_map(label))
    const t = this
    if (showError) {
      const new_state = {}
      if (v.is_required || !v.is_valid) {
        new_state[`${label}_error`] = v.is_required
          ? ' is-required'
          : ' is-error'
      } else {
        new_state[`${label}_error`] = ' is-ok'
      }
      Object.keys(v.updates.states).forEach(key => {
        new_state[key] = v.updates.states[key]
      })
      Object.keys(v.updates.stores).forEach(key => {
        const updateHandler = t.props.customerUpdate
        updateHandler({
          [key]: v.updates.stores[key],
        })
      })
      this.setState(new_state, () => {
        if (
          requireAttention &&
          document.querySelectorAll('.is-error, .is-required').length > 0
        ) {
          animateScroll.scrollTo(
            document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
              95,
            {
              smooth: true,
              dynamic: true,
            }
          )
        }
      })
    }
    return v
  }

  against_map(label) {
    const t = this

    let against = {
      dati_cliente_citta_residenza: {
        dati_cliente_caps_residenza: t.props.customer.caps_residenza || [],
      },
      dati_cliente_citta_domicilio: {
        dati_cliente_caps_domicilio: t.props.customer.caps_domicilio || [],
      },
      dati_cliente_citta_fatturazione: {
        dati_cliente_caps_fatturazione:
          t.props.customer.caps_fatturazione || [],
      },
      dati_cliente_codice_fiscale: {
        nome: t.props.customer.nome || '',
        cognome: t.props.customer.cognome || '',
        sesso: t.props.customer.sesso || '',
        data_di_nascita: t.props.customer.data_di_nascita,
        paese_comune_di_nascita: t.props.customer.comune_nascita || '',
      },
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      against = {
        ...against,
        dati_cliente_citta_consegna: {
          dati_cliente_caps_consegna: t.props.customer.caps_consegna || [],
        },
      }

      this.state.dati_cliente_cap_consegna_error = ''
    }

    return against[label]
  }

  validation_map_dati_personali() {
    const t = this
    let validation_map = {
      dati_cliente_nome: t.props.customer.nome || '',
      dati_cliente_cognome: t.props.customer.cognome || '',
      dati_cliente_phone: t.props.customer.phone || '',
      dati_cliente_email: t.props.customer.email || '',
      dati_cliente_sesso: t.props.customer.sesso || '',
      dati_cliente_data_di_nascita: t.props.customer.data_di_nascita.raw || '',
      dati_cliente_comune_nascita: t.props.customer.comune_nascita || '',
      dati_cliente_codice_fiscale: t.props.customer.codice_fiscale || '',
    }

    if (t.props.customer.partita_iva) {
      validation_map = {
        ...validation_map,
        dati_cliente_partita_iva: t.props.customer.partita_iva,
      }
    }

    if (t.props.customer.fatturazione_uguale === '0') {
      validation_map = {
        ...validation_map,
        dati_cliente_citta_fatturazione:
          t.props.customer.citta_fatturazione || '',
        dati_cliente_cap_fatturazione:
          t.state.cap_fatturazione || t.props.customer.cap_fatturazione || '',
        dati_cliente_indirizzo_fatturazione:
          t.props.customer.indirizzo_fatturazione || '',
        dati_cliente_numero_civico_fatturazione:
          t.props.customer.numero_civico_fatturazione || '',
        dati_cliente_ragione_sociale: t.props.customer.ragione_sociale || '',
      }
    }

    return validation_map
  }

  validation_map_residenza_e_domicilio() {
    const t = this
    let validation_map = {
      dati_cliente_cittadinanza: t.props.customer.cittadinanza || '',
      dati_cliente_citta_residenza: t.props.customer.citta_residenza || '',
      dati_cliente_cap_residenza:
        t.state.cap_residenza || t.props.customer.cap_residenza || '',
      dati_cliente_indirizzo_residenza:
        t.props.customer.indirizzo_residenza || '',
      dati_cliente_numero_civico_residenza:
        t.props.customer.numero_civico_residenza || '',
      dati_cliente_domicilio_diverso: t.props.customer.domicilio_diverso || '0',
      dati_cliente_fatturazione_uguale:
        t.props.customer.fatturazione_uguale || '1',
      dati_cliente_condizioni_brumbrum_obbligatorie:
        t.props.customer.condizioni_brumbrum_obbligatorie || '',
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      validation_map = {
        ...validation_map,
        dati_cliente_citta_consegna: t.props.customer.citta_consegna || '',
        dati_cliente_cap_consegna:
          t.state.cap_consegna || t.props.customer.cap_consegna || '',
        dati_cliente_indirizzo_consegna:
          t.props.customer.indirizzo_consegna || '',
        dati_cliente_numero_civico_consegna:
          t.props.customer.numero_civico_consegna || '',
      }
    }

    if (haGaranzia3Anni(t.props.garanzia)) {
      validation_map.dati_cliente_informativa_trattamento_dati_personali_garanzia =
        t.props.customer.informativa_trattamento_dati_personali_garanzia || ''
    }

    // eslint-disable-next-line
    if (t.props.customer.domicilio_diverso == '1') {
      validation_map = {
        ...validation_map,
        dati_cliente_citta_domicilio: t.props.customer.citta_domicilio || '',
        dati_cliente_cap_domicilio:
          t.state.cap_domicilio || t.props.customer.cap_domicilio || '',
        dati_cliente_indirizzo_domicilio:
          t.props.customer.indirizzo_domicilio || '',
        dati_cliente_civico_domicilio: t.props.customer.civico_domicilio || '',
      }
    }

    return validation_map
  }

  handlePrev() {
    this.setState({ section: this.state.section - 1 })
    animateScroll.scrollToTop()
  }

  handleNext() {
    const t = this
    return function () {
      const validation_map = {
        ...t.validation_map_dati_personali(),
        ...t.validation_map_residenza_e_domicilio(),
      }

      const validation_results = Object.keys(validation_map).map(
        key => t.validate(key, validation_map[key], true).is_valid
      )

      if (
        validation_results.length > 0 &&
        validation_results.indexOf(false) === -1
      ) {
        // t.setState({ section: t.state.section + 1 });
        t.props.storeDumpItForce()
        t.handleSubmit()
      }
    }
  }

  handleInput(label) {
    const t = this
    return function (event) {
      const validate_label_prefix = 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        event.target ? event.target.value : event.value
      )
      const updateHandler = t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale({
        [validate_label_prefix + label]: v.value,
      })
    }
  }

  handleSelect(label) {
    const t = this
    return function (selected) {
      const validate_label_prefix = 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        selected ? selected.value : ''
      )
      const updateHandler = t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale({
        [validate_label_prefix + label]: v.value,
      })
    }
  }

  handleRadio(label) {
    const t = this
    return function (event) {
      const validate_label_prefix = 'dati_cliente_'
      const v = t.validate(validate_label_prefix + label, event.target.value)

      const updateHandler = t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale({
        [validate_label_prefix + label]: v.value,
      })
      if (label === 'domicilio_diverso') {
        t.setState({ [label]: v })
      }
    }
  }

  handleCheckbox(label) {
    const t = this
    return function (event) {
      const validate_label_prefix = 'dati_cliente_'
      const v = t.validate(validate_label_prefix + label, event.target.checked)

      const updateHandler = t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleSubmit() {
    const t = this
    if (!this.props.fetching) {
      this.props
        .putClienti({
          cliente: this.props.customer,
          id_ordine: this.props.ordine.id_ordine,
          token: this.props.customer.token,
          callback: this.props.putClientiCallback,
          error_400: 'dati_non_corretti',
        })
        .then(() => {
          fbPixel(FB_EVENTS.CompleteRegistration, t.props.product)

          t.props.phaseChange({
            last: t.props.ui.last > 30 ? t.props.ui.last : 30,
          })
          t.props.reroute('/preview-contratto')
        })
        .catch(() => {
          t.handlePrev()
        })
    }
  }

  autoFillCodiceFiscale(newData) {
    if (newData.dati_cliente_data_di_nascita) {
      newData.dati_cliente_data_di_nascita =
        newData.dati_cliente_data_di_nascita.raw
    }
    const validation_map = {
      dati_cliente_nome: this.props.customer.nome || '',
      dati_cliente_cognome: this.props.customer.cognome || '',
      dati_cliente_sesso: this.props.customer.sesso || '',
      dati_cliente_data_di_nascita:
        this.props.customer.data_di_nascita.raw || '',
      dati_cliente_comune_nascita: this.props.customer.comune_nascita || '',
      ...newData,
    }

    const validation_results = Object.keys(validation_map).map(
      key => this.validate(key, validation_map[key], false, false).is_valid
    )

    if (
      validation_results.length > 0 &&
      validation_results.indexOf(false) === -1
    ) {
      const birthplace = getCodiceCastale(
        validation_map.dati_cliente_comune_nascita
      )
      const cf = new CodiceFiscale({
        name: validation_map.dati_cliente_nome,
        surname: validation_map.dati_cliente_cognome,
        gender: validation_map.dati_cliente_sesso,
        day: validation_map.dati_cliente_data_di_nascita.split('/')[0],
        month: validation_map.dati_cliente_data_di_nascita.split('/')[1],
        year: validation_map.dati_cliente_data_di_nascita.split('/')[2],
        birthplace,
      })
      this.props.customerUpdate({
        codice_fiscale: cf.code,
      })
      this.setState({
        calculated_codice_fiscale: cf.code,
        dati_cliente_codice_fiscale_error: ' is-ok',
      })
    }
  }

  render() {
    const { customer } = this.props
    const domicilioDiversoClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'wide' : 'wide hide'
    const domicilioDiversoThreeClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'three-t' : 'three-t hide'
    const domicilioDiversoTwoClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'two-t' : 'two-t hide'
    return (
      <form className="form-passaggio">
        <BuyDataForm active icon="user" name="section-1" title="Dati Personali">
          <li className={`${this.state.dati_cliente_nome_error} wide`}>
            <input
              className="form-input big capitalize"
              defaultValue={customer.nome || customer.name}
              label={'Nome'}
              onBlur={this.handleInput('nome')}
              placeholder={'Scrivi il tuo Nome'}
              type="text"
            />
            <label className="label">Nome</label>
            <div className="guide-tips">
              <span className="guide-tips-label">Completo di secondo nome</span>
            </div>
          </li>
          <li className={`${this.state.dati_cliente_cognome_error} wide`}>
            <input
              className="form-input big capitalize"
              defaultValue={customer.cognome || customer.surname}
              label={'Cognome'}
              onBlur={this.handleInput('cognome')}
              placeholder={'Scrivi il Cognome'}
              type="text"
            />
            <label className="label">Cognome</label>
          </li>
          <li className={`${this.state.dati_cliente_email_error} wide`}>
            <input
              className="form-input big"
              defaultValue={customer.email}
              label={'Email'}
              onBlur={this.handleInput('email')}
              placeholder={'es: mario.rossi@gmail.com'}
              type="email"
            />
            <label className="label">Email</label>
          </li>
          <li className={`${this.state.dati_cliente_phone_error} wide`}>
            <PhoneInput
              onChange={this.handleInput('phone')}
              placeholder={'Scrivi il tuo Numero di cellulare'}
              value={customer.phone}
            />
          </li>
          <li className="hr" />
          <li className="wide">
            <label>Sesso</label>
          </li>
          <BuyRadioInput
            dataCyPrefix={'dataform-sesso-'}
            defaultValue={customer.sesso}
            label={'sesso'}
            liClassName={`${this.state.dati_cliente_sesso_error} wide`}
            spanClass="value small"
            update={this.handleRadio('sesso')}
            values={[
              { label: 'Femmina', value: 'F' },
              { label: 'Maschio', value: 'M' },
            ]}
          />
          <li className="hr" />
          <li
            className={`${this.state.dati_cliente_data_di_nascita_error} wide`}
          >
            <BuyDateInput
              classes="form-input big"
              dataCy={'dataform-date'}
              defaultValue={this.props.customer.data_di_nascita.raw || ''}
              label={'Data di nascita (gg/mm/aaaa)'}
              placeholder={'00/00/0000'}
              update={this.handleInput('data_di_nascita')}
            />
          </li>
          <BuySelectInput2
            async
            dataCy={'dataform-birth-town'}
            defaultValue={customer.comune_nascita}
            label="Comune di nascita (o Stato estero)"
            liClassName={`${this.state.dati_cliente_comune_nascita_error} wide`}
            loadOptions={searchQuery => {
              const c = customer.comune_nascita
                ? customer.comune_nascita.split('|')[0]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2LuogoNascita(sq)
                .then(json => transformComuniV2Result(json.result))
            }}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect('comune_nascita')}
            values={
              this.props.comuni.searchLuogoNascita.length
                ? this.props.comuni.searchLuogoNascita
                : [
                    transformComuniNazioniDefaultValue(customer.comune_nascita),
                  ].filter(_ => _)
            }
          />
          <li className="hr" />
          <li
            className={`${this.state.dati_cliente_codice_fiscale_error} wide`}
          >
            <BuyTextInput
              classes="form-input big uppercase"
              defaultValue={customer.codice_fiscale}
              label={'Codice Fiscale'}
              onInput={event =>
                this.setState({ calculated_codice_fiscale: event.target.value })
              }
              placeholder={'Scrivi il tuo Codice Fiscale'}
              type={'text'}
              update={this.handleInput('codice_fiscale')}
              value={this.state.calculated_codice_fiscale}
            />
          </li>
          <li className="hr" />
          <li className={`${this.state.dati_cliente_partita_iva_error} wide`}>
            <BuyTextInput
              classes="form-input big uppercase"
              defaultValue={customer.partita_iva}
              label={'Partita IVA (facoltativo)'}
              placeholder={'Scrivi la Partita IVA'}
              type={'text'}
              update={this.handleInput('partita_iva')}
            />
          </li>
        </BuyDataForm>

        <BuyDataForm
          active
          icon="home"
          name="section-2"
          title="Residenza e domicilio"
        >
          <BuySelectInput2
            async
            defaultValue={
              customer.cittadinanza || {
                label: 'italiana',
                value: 'ITA|italiana',
              }
            }
            label="Cittadinanza"
            liClassName={`${this.state.dati_cliente_cittadinanza_error} wide`}
            loadOptions={searchQuery => {
              const c = customer.cittadinanza
                ? customer.cittadinanza.split('|')[1]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2Cittadinanza(sq)
                .then(
                  json =>
                    transformComuniCittadinanzaV2Result(json.result)
                      .cittadinanza
                )
            }}
            update={this.handleSelect('cittadinanza')}
            values={
              this.props.comuni.searchCittadinanza.length
                ? this.props.comuni.searchCittadinanza.cittadinanza
                : [
                    transformCittadinanzaDefaultValue(customer.cittadinanza),
                  ].filter(_ => _)
            }
          />
          <li className="hr" />
          <BuySelectInput2
            async
            dataCy={'dataform-residence-town'}
            defaultValue={customer.citta_residenza}
            label="Comune di residenza"
            liClassName={`${this.state.dati_cliente_citta_residenza_error} two-t`}
            loadOptions={searchQuery => {
              const c = customer.citta_residenza
                ? customer.citta_residenza.split('|')[0]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2Residenza(sq)
                .then(json => transformComuniResidenzaV2Result(json.result))
            }}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect('citta_residenza')}
            values={
              this.props.comuni.searchComuneResidenza.length
                ? this.props.comuni.searchComuneResidenza
                : [
                    transformComuniNazioniDefaultValue(
                      customer.citta_residenza
                    ),
                  ].filter(_ => _)
            }
          />
          {this.state.select_cap_residenza && (
            <BuySelectInput2
              clearable={false}
              dataCy={'dataform-residence-cap'}
              defaultValue={customer.cap_residenza}
              label="Cap"
              liClassName={`${this.state.dati_cliente_cap_residenza_error} three-t`}
              placeholder={'Cap'}
              update={this.handleSelect('cap_residenza')}
              values={this.state.caps_residenza}
            />
          )}
          {!this.state.select_cap_residenza && (
            <li
              className={`${this.state.dati_cliente_cap_residenza_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                dataCy={'dataform-residence-cap'}
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_residenza')}
                value={this.state.cap_residenza}
              />
            </li>
          )}
          <li
            className={`${this.state.dati_cliente_indirizzo_residenza_error} two-t`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              dataCy={'dataform-residence-address'}
              defaultValue={customer.indirizzo_residenza}
              label={'Indirizzo di residenza'}
              onInput={this.handleInput('indirizzo_residenza')}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_residenza')}
            />
          </li>
          <li
            className={`${this.state.dati_cliente_numero_civico_residenza_error} three-t`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              dataCy={'dataform-residence-number'}
              defaultValue={customer.numero_civico_residenza}
              label={'Civico'}
              onInput={this.handleInput('numero_civico_residenza')}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('numero_civico_residenza')}
            />
          </li>

          <li className="hr" />

          <li className="wide form-title">
            <label>I dati di fatturazione sono uguali alla residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={
              customer.fatturazione_uguale
                ? `${customer.fatturazione_uguale}`
                : '1'
            }
            label={'fatturazione_uguale'}
            liClassName={`${this.state.dati_cliente_fatturazione_uguale_error} wide`}
            update={this.handleRadio('fatturazione_uguale')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_ragione_sociale_error} wide`}
            >
              <BuyTextInput
                classes="form-input big uppercase"
                defaultValue={customer.ragione_sociale}
                label={'Ragione sociale (facoltativa)'}
                placeholder={'Scrivi la Ragione sociale'}
                type={'text'}
                update={this.handleInput('ragione_sociale')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <BuySelectInput2
              async
              defaultOptions
              defaultValue={customer.citta_fatturazione}
              label="Comune di fatturazione"
              liClassName={`${this.state.dati_cliente_citta_fatturazione_error} two-t`}
              loadOptions={searchQuery => {
                const c = customer.citta_fatturazione
                  ? customer.citta_fatturazione.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect('citta_fatturazione')}
              values={
                this.props.comuni.searchComuneResidenza.length
                  ? this.props.comuni.searchComuneResidenza
                  : [
                      transformComuniNazioniDefaultValue(
                        customer.citta_fatturazione
                      ),
                    ].filter(_ => _)
              }
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          this.state.select_cap_fatturazione ? (
            <BuySelectInput2
              clearable={false}
              defaultValue={customer.cap_fatturazione}
              label={'Cap'}
              liClassName={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
              placeholder={'Cap'}
              update={this.handleSelect('cap_fatturazione')}
              values={this.state.caps_fatturazione}
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          !this.state.select_cap_fatturazione ? (
            <li
              className={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_fatturazione')}
                value={this.state.cap_fatturazione || customer.cap_fatturazione}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_indirizzo_fatturazione_error} two-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_fatturazione}
                label={'Indirizzo di fatturazione'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_fatturazione')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_numero_civico_fatturazione_error} three-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.numero_civico_fatturazione}
                label={'Civico'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_fatturazione')}
              />
            </li>
          ) : null}

          <li className="hr" />
          <li className="wide form-title">
            <label>Il domicilio è diverso dall’indirizzo di residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={customer.domicilio_diverso || '0'}
            label={'domicilio_diverso'}
            liClassName={`${this.state.dati_cliente_domicilio_diverso_error} wide`}
            update={this.handleRadio('domicilio_diverso')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          <li className={`${domicilioDiversoClasses} hr`} />
          <BuySelectInput2
            async
            defaultOptions
            defaultValue={customer.citta_domicilio}
            label="Comune di domicilio"
            liClassName={`${domicilioDiversoTwoClasses.concat(
              this.state.dati_cliente_citta_domicilio_error
            )} two-t`}
            loadOptions={searchQuery => {
              const c = customer.citta_domicilio
                ? customer.citta_domicilio.split('|')[0]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2Residenza(sq)
                .then(json => transformComuniResidenzaV2Result(json.result))
            }}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect('citta_domicilio')}
            values={
              this.props.comuni.searchComuneResidenza.length
                ? this.props.comuni.searchComuneResidenza
                : [
                    transformComuniNazioniDefaultValue(
                      customer.citta_domicilio
                    ),
                  ].filter(_ => _)
            }
          />

          {this.state.select_cap_domicilio && (
            <BuySelectInput2
              clearable={false}
              defaultValue={customer.cap_domicilio}
              label="Cap"
              liClassName={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
              placeholder={'Cap'}
              update={this.handleSelect('cap_domicilio')}
              values={this.state.caps_domicilio}
            />
          )}
          {!this.state.select_cap_domicilio && (
            <li
              className={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_domicilio')}
                value={this.state.cap_domicilio || customer.cap_domicilio}
              />
            </li>
          )}
          <li
            className={domicilioDiversoTwoClasses.concat(
              this.state.dati_cliente_indirizzo_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.indirizzo_domicilio}
              label={'Indirizzo di domicilio'}
              onInput={this.handleInput('indirizzo_domicilio')}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_domicilio')}
            />
          </li>
          <li
            className={domicilioDiversoThreeClasses.concat(
              this.state.dati_cliente_civico_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.civico_domicilio}
              label={'Civico'}
              onInput={this.handleInput('civico_domicilio')}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('civico_domicilio')}
            />
          </li>

          {/* scelta consegna */}

          <BuyDataForm
            active={
              this.props.logistica.centro_convenzionato.tipologia_consegna ===
              'Consegna a casa'
            }
            icon="home"
            id={'consegna_domicilio'}
            name="section-consegna-domicilio"
            title="Indirizzo per la consegna della tua auto"
          >
            {this.props.customer.citta_residenza &&
            this.props.customer.cap_residenza &&
            this.props.customer.indirizzo_residenza &&
            this.props.customer.numero_civico_residenza ? (
              <li style={{ margin: '0', width: '50%' }}>
                <label
                  className="r-checkbox long"
                  data-cy="dataform-copy-from-residence"
                >
                  <input
                    checked={this.state.flagResidenza}
                    name="flagResidenza"
                    onChange={() => {
                      this.setState(
                        prevState => ({
                          flagResidenza: !prevState.flagResidenza,
                        }),
                        () => {
                          if (this.state.flagResidenza) {
                            this.setState(
                              {
                                flagDomicilio: false,
                              },
                              () => {
                                this.handleSelect('citta_consegna')({
                                  value: this.props.customer.citta_residenza,
                                })
                                this.handleSelect('cap_consegna')({
                                  value: this.props.customer.cap_residenza,
                                })
                                this.handleInput('indirizzo_consegna')({
                                  value:
                                    this.props.customer.indirizzo_residenza,
                                })
                                this.handleInput('numero_civico_consegna')({
                                  value:
                                    this.props.customer.numero_civico_residenza,
                                })
                              }
                            )
                          }

                          if (
                            !this.state.flagResidenza &&
                            !this.state.flagDomicilio
                          ) {
                            this.handleSelect('citta_consegna')({
                              value: '',
                            })
                            this.handleSelect('cap_consegna')({
                              value: '',
                            })
                            this.handleInput('indirizzo_consegna')({
                              value: ' ',
                            })
                            this.handleInput('numero_civico_consegna')({
                              value: ' ',
                            })

                            this.cleanUpField(this.refCivicoConsegna)
                            this.cleanUpField(this.refIndirizzoConsegna)
                          }
                        }
                      )
                    }}
                    type="checkbox"
                  />
                  <span className="check"></span>
                  Copia da residenza
                </label>
              </li>
            ) : null}

            {this.props.customer.domicilio_diverso === '1' &&
            this.props.customer.citta_domicilio &&
            this.props.customer.cap_domicilio &&
            this.props.customer.indirizzo_domicilio &&
            this.props.customer.civico_domicilio ? (
              <li style={{ margin: '0', width: '50%' }}>
                <label className="r-checkbox long">
                  <input
                    checked={this.state.flagDomicilio}
                    name="flagDomicilio"
                    onChange={() => {
                      this.setState(
                        prevState => ({
                          flagDomicilio: !prevState.flagDomicilio,
                        }),
                        () => {
                          if (this.state.flagDomicilio) {
                            this.setState(
                              {
                                flagResidenza: false,
                              },
                              () => {
                                this.handleSelect('citta_consegna')({
                                  value: this.props.customer.citta_domicilio,
                                })
                                this.handleSelect('cap_consegna')({
                                  value: this.props.customer.cap_domicilio,
                                })
                                this.handleInput('indirizzo_consegna')({
                                  value:
                                    this.props.customer.indirizzo_domicilio,
                                })
                                this.handleInput('numero_civico_consegna')({
                                  value: this.props.customer.civico_domicilio,
                                })
                              }
                            )
                          }

                          if (
                            !this.state.flagResidenza &&
                            !this.state.flagDomicilio
                          ) {
                            this.handleSelect('citta_consegna')({
                              value: '',
                            })
                            this.handleSelect('cap_consegna')({
                              value: '',
                            })
                            this.handleInput('indirizzo_consegna')({
                              value: ' ',
                            })
                            this.handleInput('numero_civico_consegna')({
                              value: ' ',
                            })

                            this.cleanUpField(this.refCivicoConsegna)
                            this.cleanUpField(this.refIndirizzoConsegna)
                          }
                        }
                      )
                    }}
                    type="checkbox"
                  />
                  <span className="check"></span>
                  Copia da domicilio
                </label>
              </li>
            ) : null}

            <li className="hr" style={{ margin: '20px 0' }} />

            {this.props.comuni &&
            this.props.comuni.comune &&
            !this.state.flagResidenza &&
            !this.state.flagDomicilio ? (
              <BuySelectInput2
                async
                creatable={false}
                defaultValue={customer.citta_consegna}
                label="Comune di consegna"
                liClassName={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                loadOptions={searchQuery => {
                  const c = customer.citta_consegna
                    ? customer.citta_consegna.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props
                    .searchComuniV2Residenza(sq)
                    .then(json => transformComuniResidenzaV2Result(json.result))
                }}
                name={'dati_cliente_citta_consegna'}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('citta_consegna')}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.citta_consegna
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}

            {this.props.comuni &&
              this.props.comuni.comune &&
              (this.state.flagResidenza || this.state.flagDomicilio) && (
                <li
                  className={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                >
                  <BuyTextInput2
                    classes="input-data form-input big"
                    defaultValue={customer.citta_consegna}
                    disabled
                    label="Comune di consegna"
                    name={'dati_cliente_citta_consegna'}
                    placeholder={'Seleziona il Comune'}
                    update={this.handleSelect('citta_consegna')}
                    value={
                      transformComuniNazioniDefaultValue(
                        customer.citta_consegna
                      ) &&
                      transformComuniNazioniDefaultValue(
                        customer.citta_consegna
                      ).label
                    }
                  />
                </li>
              )}

            {this.state.select_cap_consegna &&
              !this.state.flagResidenza &&
              !this.state.flagDomicilio && (
                <BuySelectInput2
                  defaultValue={customer.cap_consegna}
                  label="Cap"
                  liClassName={`${this.state.dati_cliente_cap_consegna_error} three-t`}
                  name={'dati_cliente_cap_consegna'}
                  placeholder={'Cap'}
                  update={this.handleSelect('cap_consegna')}
                  values={this.state.caps_consegna}
                />
              )}
            {this.state.select_cap_consegna &&
              (this.state.flagResidenza || this.state.flagDomicilio) && (
                <li
                  className={`${this.state.dati_cliente_cap_consegna_error} three-t`}
                >
                  <BuyTextInput2
                    classes="input-data form-input big"
                    defaultValue={customer.cap_consegna}
                    disabled
                    label={'Cap'}
                    placeholder={'Cap'}
                    type={'number'}
                    update={this.handleInput('cap_consegna')}
                    value={customer.cap_consegna}
                  />
                </li>
              )}

            <li
              className={`two-t ${this.state.dati_cliente_indirizzo_consegna_error}`}
              ref={this.refIndirizzoConsegna}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_consegna}
                disabled={this.state.flagDomicilio || this.state.flagResidenza}
                label={'Indirizzo di consegna'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_consegna')}
                value={
                  this.state.flagDomicilio || this.state.flagResidenza
                    ? customer.indirizzo_consegna
                    : null
                }
              />
            </li>
            <li
              className={`three-t ${this.state.dati_cliente_numero_civico_consegna_error}`}
              ref={this.refCivicoConsegna}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.numero_civico_consegna}
                disabled={this.state.flagDomicilio || this.state.flagResidenza}
                label={'Civico'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_consegna')}
                value={
                  this.state.flagDomicilio || this.state.flagResidenza
                    ? customer.numero_civico_consegna
                    : null
                }
              />
            </li>
          </BuyDataForm>

          <li className="hr" />
          <li
            className={`${this.state.dati_cliente_condizioni_brumbrum_obbligatorie_error} wide`}
          >
            <label
              className="r-checkbox long"
              data-cy="dataform-general-conditions"
            >
              <input
                defaultChecked={
                  !!(
                    customer.condizioni_brumbrum_obbligatorie ||
                    // eslint-disable-next-line
                    customer.condizioni_brumbrum_obbligatorie == '1'
                  )
                }
                name="condizioni_brumbrum_obbligatorie"
                onChange={this.handleCheckbox(
                  'condizioni_brumbrum_obbligatorie'
                )}
                type="checkbox"
              />
              <span className="check"></span>
              Ho preso visione e accetto le{' '}
              <a
                href={mapfreCondizioniGeneraliContratto}
                rel="noreferrer"
                target="_blank"
              >
                Condizioni Generali di Contratto
              </a>{' '}
              del sito web brumbrum.it
            </label>
          </li>
          {haGaranzia3Anni(this.props.garanzia) && (
            <li
              className={`${this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error} wide`}
            >
              <label className="r-checkbox long">
                <input
                  defaultChecked={
                    !!(
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        1 ||
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        '1'
                    )
                  }
                  name="informativa_trattamento_dati_personali_garanzia"
                  onChange={this.handleCheckbox(
                    'informativa_trattamento_dati_personali_garanzia'
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                Ho preso visione e accetto il{' '}
                <a
                  href={mapfreProgrammaGaranzia}
                  rel="noreferrer"
                  target="_blank"
                >
                  Programma di Garanzia Convenzionale
                </a>
                , il{' '}
                <a
                  href={mapfreAssistenzaStradale}
                  rel="noreferrer"
                  target="_blank"
                >
                  Programma di Assistenza Stradale
                </a>{' '}
                e l'
                <a
                  href={mapfreInformativaDatiPersonali}
                  rel="noreferrer"
                  target="_blank"
                >
                  Informativa sul trattamento dei dati personali
                </a>{' '}
                del gestore del programma di garanzia
              </label>
            </li>
          )}

          <DocumentiHelperModal
            display={this.state.show_condizioni_generali_di_contratto_modal}
            iframeSrc={`${window.location.origin}/condizioni-contratto/v2?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`}
            modalTitle="Condizioni Generali di Contratto"
            onClose={() => {
              this.setState({
                show_condizioni_generali_di_contratto_modal: false,
              })
            }}
          />

          <BuyTerminiDiUtilizzo
            display={this.state.show_termini_di_utilizzo_modal}
            onClose={() => {
              this.setState({ show_termini_di_utilizzo_modal: false })
            }}
          />

          <li className="hr" />

          <li className="wide buttons">
            <a
              className={`btn btn-primary js-next-step${
                this.props.fetching ? ' btn-disabled' : ''
              }`}
              data-cy="dataform-submit"
              onClick={this.handleNext()}
            >
              <span>Prosegui</span>
            </a>
          </li>
        </BuyDataForm>
      </form>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customer,
  product: state.product,
  ordine: state.ordine,
  compass_tabelledominio: state.compass_tabelledominio,
  comuni: state.comuni,
  fetching: state.ui.fetching,
  logistica: state.logistica,
  ui: state.ui,
  error: state.error,
  garanzia: state.garanzia,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: phase => dispatch(phaseChange(phase)),
  customerUpdate: payload => dispatch(customerUpdate(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  putClienti: payload => dispatch(putClienti(payload)),
  putClientiCallback: payload => dispatch(putClientiCallback(payload)),
  reroute: payload => dispatch(reroute(payload)),
  searchComuniV2LuogoNascita: searchQuery =>
    dispatch(searchComuniV2LuogoNascita(searchQuery)),
  searchComuniV2Cittadinanza: searchQuery =>
    dispatch(searchComuniV2Cittadinanza(searchQuery)),
  searchComuniV2Residenza: searchQuery =>
    dispatch(searchComuniV2Residenza(searchQuery)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BuyDataFormBank)
